let dirty = false;
let domDirty = false;
const forms = new Map<symbol, boolean>();
export const hasApplicationDraft = () => dirty || (forms.size ? [...forms.values()].some(Boolean) : domDirty);
export const markApplicationDraft = () => { dirty = true; };
export const markApplicationDomDraft = () => { domDirty = true; };
export const clearApplicationDraft = () => { dirty = false; domDirty = false; for (const key of forms.keys()) forms.set(key, false); };
export const trackApplicationForm = (key: symbol, changed: boolean) => { forms.set(key, changed); };
export const untrackApplicationForm = (key: symbol) => { forms.delete(key); if (!forms.size) domDirty = false; };
